module.exports = __webpack_public_path__ + "static/img/img-features-feature-3-list-m@3x.6d93aec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-3-list-m@3x.png
// module id = qCKp
// module chunks = 18